import React from 'react';
import { Row, Col } from 'react-bootstrap';
import LoadingSpinner from 'components/LoadingSpinner';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectSimilaridadeVariavel,
  selectSimilaridadeMapsData,
  selectSimilaridadeMapsLoading,
  removeMapData,
} from 'redux/reducers/similaridadeReducer';
import AnomalyMap from 'components/DesignSystem/AnomalyMap';

export default function MapGridSection() {
  const dispatch = useDispatch();
  const selectedVariable = useSelector(selectSimilaridadeVariavel);
  const maps = useSelector(selectSimilaridadeMapsData);
  const loading = useSelector(selectSimilaridadeMapsLoading);

  if (loading) {
    return (
      <div className="text-center p-4">
        <LoadingSpinner />
        <p>Gerando mapas de similaridade...</p>
      </div>
    );
  }

  if (!selectedVariable) {
    return (
      <div className="text-center p-4">
        <div className="alert alert-info">
          <h5>Mapas de Similaridade</h5>
          <p>
            Selecione uma variável no painel lateral e um mês na
            tabela abaixo para visualizar os mapas.
          </p>
        </div>
      </div>
    );
  }

  if (maps.length === 0) {
    return (
      <div className="text-center p-4">
        <div className="alert alert-info">
          <h5>Mapas de Similaridade</h5>
          <p>
            Selecione pelo menos um mês na tabela abaixo e clique em &quot;Gerar Mapas&quot;
            {' '}
            para visualizar os mapas de similaridade.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-4">
      <h4>
        Mapas de Anomalia -
        {' '}
        {selectedVariable}
      </h4>
      <Row style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {maps.map((map) => (
          <Col
            key={`${map.ano}-${map.nome}`}
            lg={4}
            md={6}
            sm={12}
            className="mb-3"
          >
            <AnomalyMap
              title={map.ano}
              dataSource={selectedVariable}
              imageUrl={map.link}
              onClose={() => dispatch(removeMapData({ ano: map.ano, mes: map.mes }))}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}
